var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"complaint",style:(_vm.complaintStyle),attrs:{"data-test-id":"Complaint"},on:{"click":function($event){return _vm.onClick(_vm.complaint)}}},[_c('span',[_vm._v(_vm._s(_vm.complaint.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }